export default __webpack_public_path__ + "static/media/remove.3e460dac.png";